import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

type SortConfig = { key: string; direction: "ASC" | "DESC" };

export interface useDataTableStateStates {
  pageSizeOptions: number[]
  sortConfig: { key: string; direction: "ASC" | "DESC" };
  setSortConfig: (cfg: { key: string; direction: "ASC" | "DESC" }) => void;
  currentPage: number;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
  pageSize: number;
  setPageSize: React.Dispatch<React.SetStateAction<number>>;
  filter: string;
  setFilter: React.Dispatch<React.SetStateAction<string>>;
}

export function useDataTableState(
  initialSortKey: string,
  pageSizeOptions = [7, 12, 20, 50, 100, 500, 1000],
  initialSortDirection: 'ASC' | 'DESC' = 'ASC',
) {

  const [sortConfig, setSortConfig] = useState<SortConfig>({
    key: initialSortKey,
    direction: initialSortDirection,
  });

  const [searchParams, setSearchParams] = useSearchParams();

  const [currentPage, setCurrentPage] = useState(() => {
    const pageParam = Number(searchParams.get("page"));
    if (pageParam && pageParam > 0)
      return pageParam
    else return 1
  })

  const [pageSize, setPageSize] = useState(pageSizeOptions[1]);
  const [filter, setFilter] = useState(() => searchParams.get("q") ?? "");

  useEffect(() => {
    setSearchParams(prev => {
      const newParams = new URLSearchParams(prev);
      newParams.set("page", String(currentPage));
      if (filter.trim()) {
        newParams.set("q", filter);
      } else {
        newParams.delete("q");
      }
      return newParams;
    }, { replace: true }
    );
  }, [currentPage, filter, setSearchParams]);

  const r: useDataTableStateStates = {
    pageSizeOptions,
    sortConfig,
    setSortConfig,
    currentPage,
    setCurrentPage,
    pageSize,
    setPageSize,
    filter,
    setFilter,
  }

  return r;
}
